/**
 * all actions for portfolio state
 *
 * Created by Tom on 16/06/18
 */

import C from '../constants'


// action to hide/show the loader for the portfolio
export const showPortfolioLoader = booleanVal => {
    return {
        type: C.SET_PORTFOLIO_LOADER,
        payload: booleanVal
    }
}

// action to set the portfolio data
export const setPortfolioData = objectVal => {
    return {
        type: C.SET_PORTFOLIO_DATA,
        payload: objectVal
    }
}

// action to set the portfolio fetch success state
export const setPortfolioFetchSuccess = booleanVal => {
    return {
        type: C.SET_PORTFOLIO_FETCH_SUCCESS,
        payload: booleanVal
    }
}

// action to set the portfolio fund value
export const setPortfolioFundValue = numberVal => {
    return {
        type: C.SET_PORTFOLIO_FUND_VALUE,
        payload: numberVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the data
// NOTE: this will be picked up by the portfolio saga (sagas/portfolioSaga.js)
export const getPortfolioData = () => {
    return {
        type: C.FETCH_PORTFOLIO_DATA
    }
}



// WEBPACK FOOTER //
// ./src/actions/portfolioActions.js